 
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  var React = require('react');
} 

var I18N = I18N || {}

I18N.locale = 'en';
I18N.passthrough = 'en',
I18N.logMissing  =  false,
I18N.logExisting =  true,
I18N.highlightMissing = false;
I18N.missing =  {};
I18N.notExisting =  {};
I18N.map = {};

I18N.setLocale = function( locale ) 
{
   locale = locale.replace(/_../,'');
   I18N.locale = locale;          
   if (window.I18NFile.all) {
     var newMap = {};
     var phrase = "";
     for (phrase in window.I18NFile.all) {
       if (window.I18NFile.all[phrase][I18N.locale]) {
          newMap[phrase] = window.I18NFile.all[phrase][I18N.locale];
       }
     }
     I18N.map = newMap;
   } else {
     I18N.map = I18N[I18N.locale]; 
     if ( I18N.map == undefined ) {
       console.log("I18N WARNING: missing locale file?");
       I18N.map = {};
     }
   }  
}

function i18n(arg1, arg2) 
{
  function getText(t) {
  
    // console.log('getText', t);
    // console.log('getText 2', I18N.map[t]);
    // console.log('getText 3', window.I18NFile.all[t] );
  
    if (I18N.map[t]) {
      return I18N.map[t];
    }
    if (I18N.locale == I18N.passthrough) {
      return t;
    }
    if (I18N.logMissing) {
      //console.log('missing translation for '+I18N.locale+'"'+arg1+'"');
      I18N.missing[t] = "";
    }
    if (I18N.highlightMissing) {
      return "!!MISS:"+t+":MISS!!";
    }
    if (window.I18NFile.all[t] && window.I18NFile.all[t][I18N.passthrough]) {
      return window.I18NFile.all[t][I18N.passthrough];
    } else {
      if (I18N.logExisting && ! window.I18NFile.all[t]) {
        I18N.notExisting[t] = "";
      }
    }             
    return t;
  }
  function getTextWithBRs(t) {
     var a = t.split('<br>');
     if (a.length < 2) { return t }
     var out = [ a[0] ]
     for (var i=1; i<a.length; i++) {
        out.push(React.createElement('br', {}));
        out.push( a[i] );
     }
     out.toString = function() { return t; };
     return out;                        
  }
  if (typeof arg1 === "string" && arg2 == null) {
    return getTextWithBRs(getText(arg1));
  }        
  if (arg1 == null && typeof arg2 === "string") {
    return getTextWithBRs(getText(arg2));
  }
}
var T = i18n; // shorter version

/*exports.i18n = i18n;
exports.I18N = I18N;*/

function I18NReportMissing () 
{
  var t = '';
  for (key in I18N.missing) {
    t += '"'+key+'": "", \n';
  }
  if (t != '') {
    console.log('I18N.missing:');
    console.log(t);
  }  
  I18N.missing = {};
}

function I18NReportMNotExisting () 
{
  var t = '';
  for (key in I18N.notExisting) {
    t += '"'+key+'": "", \n';
  }
  if (t != '') {
    console.log('I18N.notExisting:');
    console.log(t);
  }  
  I18N.notExisting = {};
}
setInterval( I18NReportMNotExisting , 8000);


       function fmDate ( dateStr  )
       {
         if (!dateStr || dateStr == "" ) return "";
         var d = new Date(dateStr);                

         var curr_date  = d.getUTCDate(); 
         var curr_month = d.getUTCMonth();
         var curr_year  = d.getUTCFullYear();
 
         var monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
                                                                                                    
         return (curr_date + " " + monthNames[curr_month] + " " + curr_year);                       
       }
       
       function fmDateTime ( dateStr  )
       {
         if (!dateStr || dateStr == "" ) return "";
         var d = new Date(dateStr);                

         var curr_date  = d.getUTCDate(); 
         var curr_month = d.getUTCMonth();
         var curr_year  = d.getUTCFullYear();
         var curr_hour  = d.getUTCHours();
         var curr_min   = d.getUTCMinutes();
         var curr_sec   = d.getUTCSeconds();

 
         var monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
                                                                                                    
         return (curr_date + " " + 
                 monthNames[curr_month] + " " + 
                 curr_year + " " +
                 (curr_hour < 10 ? '0'+curr_hour : curr_hour) + ":" +
                 (curr_min  < 10 ? '0'+curr_min  : curr_min ) + ":" +
                 (curr_sec  < 10 ? '0'+curr_sec  : curr_sec ) 
                );
       }
       

       function fmNum( numStr ) 
       {
         if ( typeof numStr !== "number") return numStr;
         if (!numStr || numStr == ""  || numStr == null   || numStr == '0') return "0.00";
         var floatNum = parseFloat(numStr).toFixed(2).toString();           
         var floatNumWithSep = floatNum.toString().split(".");     
         floatNumWithSep[0] = floatNumWithSep[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");     
         return floatNumWithSep.join("."); 
       }

I18N.getLocalizedText = function( text ) {
  var mapIsEmpty=true;

  if ( I18N.map ) {
    for (var key in I18N.map) {
      if (hasOwnProperty.call(I18N.map, key)) {mapIsEmpty=false; break;}
    }
  }
  // If map is empty then try to pick from all localized string
  if ( ! mapIsEmpty ) {
    translatedText = T(text);
  } else {
    translatedText = window.I18NFile.all[text];
    if ( translatedText && translatedText[I18N.locale] ) {
      translatedText = translatedText[I18N.locale];
    } else if ( translatedText && translatedText['en'] ) {
      translatedText = translatedText['en'];
    } else {
      translatedText = text;
    }
  }

  return translatedText;
}

if (typeof(exports) != "undefined") {
  exports.i18n = i18n;
  exports.I18N = I18N;
  exports.fmDate = fmDate;
  exports.fmDateTime = fmDateTime;
  exports.fmNum = fmNum;
}
